import { animated, config, useSpring } from "@react-spring/web";
import { useEffect } from "react";

type IntegrationLogosProps = {
  logo?: string;
  active?: boolean;
};

export default function IntegrationLogos({
  logo,
  active,
}: IntegrationLogosProps) {
  const [spring, api] = useSpring(() => ({
    progress: 0,
    config: config.gentle,
    immediate: false,
    delay: 200,
  }));

  useEffect(() => {
    api.start({ progress: active ? 1 : 0 });
  }, [active, api]);

  if (!logo) {
    return <img src="/logo.png" className="h-[32px] object-contain" />;
  }

  const logoTrransform = spring.progress
    .to([0, 1], [-30, 0])
    .to((x) => `rotate(${x}deg)`);

  const integrationLogoTransform = spring.progress
    .to([0, 1], [30, 0])
    .to((x) => `rotate(${x}deg)`);

  return (
    <>
      <animated.div style={{ transform: logoTrransform }}>
        <img src="/logo.png" className="h-[32px] object-contain" />
      </animated.div>
      {logo && (
        <>
          <span className="text-black/50 mx-[16px]">×</span>
          <animated.div style={{ transform: integrationLogoTransform }}>
            <img src={logo} className="h-[32px] object-contain max-w-[80px]" />
          </animated.div>
        </>
      )}
    </>
  );
}
